<template>
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M7.9306 3H16.3653C19.3134 3 21.1484 5.08119 21.1484 8.02638V15.9736C21.1484 18.9188 19.3134 21 16.3643 21H7.9306C4.98249 21 3.14844 18.9188 3.14844 15.9736V8.02638C3.14844 5.08119 4.99125 3 7.9306 3Z"
      stroke="#A3A3A3"
      stroke-width="1.5"
      stroke-linecap="round"
      stroke-linejoin="round" />
    <path
      d="M6.99219 20.9202V20.0153C6.99219 18.3321 8.32516 16.2305 12.1489 16.2305C15.9824 16.2305 17.3154 18.3126 17.3154 19.9959V20.9202"
      stroke="#A3A3A3"
      stroke-width="1.5"
      stroke-linecap="round"
      stroke-linejoin="round" />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M15.4473 10.5259C15.4473 12.3464 13.9723 13.8214 12.1518 13.8214C10.3314 13.8214 8.85547 12.3464 8.85547 10.5259C8.85547 8.7055 10.3314 7.23047 12.1518 7.23047C13.9723 7.23047 15.4473 8.7055 15.4473 10.5259Z"
      stroke="#A3A3A3"
      stroke-width="1.5"
      stroke-linecap="round"
      stroke-linejoin="round" />
  </svg>
</template>
